<template>
	<inertia-head title="TRC Stock Updates" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Stock Updates</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Exclusive stock updates to become one step ahead with other
						investors
					</h2>
				</div>
			</div>
		</div>
	</div>

	<div class="content mt-5">

		<button
			@click="
				$inertia.visit('/member/updates/stock-updates/details/'+trcCoupleBlogDetails.couple_blog_uuid, {
					preserveScroll: false,
				})
			"
			id="scroll_top"
			class="btn btn-secondary opacity-75 d-none"
		>
			<i class="fa fa-arrow-up"></i>
		</button>

		<button
			@click="
				$inertia.visit(route('member.trc-couple.blogs'), {
					preserveScroll: false,
				})
			"
			class="btn btn-secondary opacity-75"
		>
			<i class="fa fa-arrow-left me-1"></i>Go Back
		</button>

		<div v-if="trcCoupleBlogDetails!==null" class="row pb-4 justify-content-center">
			<!--START Posts -->
			<div class="col-xl-10 col-lg-10 col-md-10 mt-5">
				<div>
					<div
						class="overflow-hidden rounded mb-3 bg-image text-center"
						style="height: 200px;"
					>
					<img :src="trcCoupleBlogDetails.blog_image_url" class="img-fluid w-100 h-100 img-obj-fit" alt="stock update image">
					</div>
				</div>
				<div class="p-3 pt-0">
					<p class="mb-1 h2">{{ trcCoupleBlogDetails.blog_title }}</p>
					<div class="fs-sm fw-medium text-muted mb-2">
						<span class="me-3 fs-xs">
							<i class="fa fa-fw fa-calendar-alt opacity-50 me-1"></i>
							{{ trcCoupleBlogDetails.date_start }}
						</span>
					</div>
				</div>
				<div class="p-3 pt-0">
					<div style="white-space: pre; white-space:break-spaces;overflow: hidden;" v-html="trcCoupleBlogDetails.blog_desc"></div>
				</div>
			</div>
			<hr class="d-xl-none" />
			<!-- END Posts -->

		</div>
	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);
	
import axios from 'axios'
import { debounce } from 'lodash'
import { onMounted, ref, reactive } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'

export default {
	layout: AuthLayout,
	props: {
		trcCoupleBlogDetails: Object,
	},
	setup(props) {
		const modal 			= ref(null);
		let trcCoupleBlogDetails 		= ref(props.trcCoupleBlogDetails[0]??null);

		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')


			window.addEventListener(
				'scroll',
				debounce((e) => {

					if (
						document.body.scrollTop > 20 ||
						document.documentElement.scrollTop > 20
					) {
						document.getElementById('scroll_top').classList.remove('d-none')
					} else {
						document.getElementById('scroll_top').classList.add('d-none')
					}
				}, 100)
			)

		})

		
		return {
			modal,
			trcCoupleBlogDetails
		}
	},
}
</script>
